import { createAction, props } from '@ngrx/store';


export const loadSurvey = createAction(
  '[Dashboard] Load Survey',
  props<any>()
);

export const loadSurveySuccess = createAction(
  '[Dashboard] Load Survey Success',
  props<{ data: any }>()
);

export const loadSurveyFailure = createAction(
  '[Dashboard]  Load Survey Failure',
  props<{ error: any }>()
);

export const loadRecord = createAction(
  '[Dashboard] Load Record',
  props<any>()
);

export const loadRecordSuccess = createAction(
  '[Dashboard] Load Record Success',
  props<{ data: any }>()
);

export const loadRecordFailure = createAction(
  '[Dashboard]  Load Record Failure',
  props<{ error: any }>()
);

export const resetSurvey = createAction(
  '[Dashboard] Reset Survey',
  props<{ error: any }>()
);